import { render, staticRenderFns } from "./Mp4Modal.vue?vue&type=template&id=188dd219&scoped=true&lang=pug"
import script from "./Mp4Modal.vue?vue&type=script&lang=ts"
export * from "./Mp4Modal.vue?vue&type=script&lang=ts"
import style0 from "./Mp4Modal.vue?vue&type=style&index=0&id=188dd219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188dd219",
  null
  
)

export default component.exports